import { Component } from 'nuxt-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import Validator from './validation'

@Component({})
export default class LavoraConValidator extends Validator {
  @Validations()
  validations = {
    form: {
      name: { required },
      email: { required, email },
      body: { required },
      file: {},
      privacy: {
        sameAs: sameAs(() => true),
      },
    },
  }
}
